import { render, staticRenderFns } from "./tzz_zc_zg.vue?vue&type=template&id=370875b7&scoped=true"
import script from "./tzz_zc_zg.vue?vue&type=script&lang=js"
export * from "./tzz_zc_zg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370875b7",
  null
  
)

export default component.exports